module.exports = __webpack_public_path__ + "static/img/wenhua11.2bcc5a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua11.jpg
// module id = /CxK
// module chunks = 1